import axios from 'axios';
import { API_BASE_URL } from '../constants/config';
import { getAccessToken, getDeviceId, clearSession } from '../utils/session';

const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  timeout: 20000,
  headers: { 'Content-Type': 'application/json' },
});

axiosInstance.interceptors.request.use((config) => {
  const token = getAccessToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  config.headers['x-device-id'] = getDeviceId();
  return config;
});

axiosInstance.interceptors.response.use(
  (res) => res,
  (err) => {
    const isAuthRequest = /\/auth\/(login|register)(?:\?|$)/.test(err.config?.url || '');
    if (err.response?.status === 401 && !isAuthRequest) {
      clearSession();
      window.dispatchEvent(new Event('auth:unauthorized'));
    }
    return Promise.reject(err);
  }
);

export default axiosInstance;
